// Function to convert hex to RGB
function hexToRgb(hex) {
    let bigint = parseInt(hex.slice(1), 16);
    let r = (bigint >> 16) & 255;
    let g = (bigint >> 8) & 255;
    let b = bigint & 255;
    return [r, g, b];
}

// Function to convert RGB to hex
function rgbToHex(r, g, b) {
    return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1).toUpperCase();
}

// Function to lighten or darken a color
function shadeColor(hex, percent) {
    let [r, g, b] = hexToRgb(hex);

    r = Math.min(255, Math.max(0, Math.floor(r * (1 + percent))));
    g = Math.min(255, Math.max(0, Math.floor(g * (1 + percent))));
    b = Math.min(255, Math.max(0, Math.floor(b * (1 + percent))));

    return rgbToHex(r, g, b);
}

// Tab panel funcs
window.addEventListener("load", function() {
    const tabPanels = document.querySelectorAll(".tab-panel");

    for (const tabPanel of tabPanels) {
        const tabButtons = tabPanel.querySelectorAll('button[data-tab]');
        const tabContent = tabPanel.querySelector('[data-tab-content]');
        const primaryFillUpdates = tabPanel.querySelectorAll('.fill-update-target-primary');
        const secondaryFillUpdates = tabPanel.querySelectorAll('.fill-update-target-secondary');
        const tertiaryFillUpdates = tabPanel.querySelectorAll('.fill-update-target-tertiary');
        const initPrimaryFill = tabButtons[0].dataset.colour;

        // Initial fill updates
        const lighterColour = shadeColor(initPrimaryFill, 0.75);  // 75% lighter
        const darkerColour = shadeColor(initPrimaryFill, -0.75);  // 75% darker

        primaryFillUpdates.forEach(fillUpdate => {
            fillUpdate.style.fill = initPrimaryFill;
        });

        secondaryFillUpdates.forEach(fillUpdate => {
            if (fillUpdate.hasAttribute('stop-color')) {
                fillUpdate.setAttribute('stop-color', lighterColour);
            } else {
                fillUpdate.style.fill = lighterColour;
            }
        });

        tertiaryFillUpdates.forEach(fillUpdate => {
            if (fillUpdate.hasAttribute('stop-color')) {
                fillUpdate.setAttribute('stop-color', darkerColour);
            } else {
                fillUpdate.style.fill = darkerColour;
            }
        });

        // Tab button click event
        tabButtons.forEach(button => {
            button.addEventListener('click', function() {
                const clickedTab = button.dataset.tab;
                const tabColor = button.dataset.colour;

                const newLighterColour = shadeColor(tabColor, 0.75);
                const newDarkerColour = shadeColor(tabColor, -0.75);

                // Reset all tabs
                const allTabs = tabContent.querySelectorAll('[data-tab]');
                allTabs.forEach(tab => {
                    tab.style.gridTemplateRows = "";
                });

                tabButtons.forEach(button => {
                    button.dataset.active = 'false';
                });

                button.dataset.active = 'true';

                // Activate the clicked tab
                const activeTabs = tabContent.querySelectorAll(`[data-tab="${clickedTab}"]`);
                activeTabs.forEach(activeTab => {
                    activeTab.style.gridTemplateRows = "1fr";
                });

                // Update fills with the clicked tab color
                primaryFillUpdates.forEach(fillUpdate => {
                    fillUpdate.style.fill = tabColor || "";
                });

                secondaryFillUpdates.forEach(fillUpdate => {
                    if (fillUpdate.hasAttribute('stop-color')) {
                        fillUpdate.setAttribute('stop-color', newLighterColour);
                    } else {
                        fillUpdate.style.fill = newLighterColour || "";
                    }
                });

                tertiaryFillUpdates.forEach(fillUpdate => {
                    if (fillUpdate.hasAttribute('stop-color')) {
                        fillUpdate.setAttribute('stop-color', newDarkerColour);
                    } else {
                        fillUpdate.style.fill = newDarkerColour || "";
                    }
                });

                // Set border-left-color on tab content
                tabContent.style.borderColor = tabColor || "";
            });
        });
    }
});
